import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing.component';
import { CaseFormsComponent } from '../modules/case-forms/case-forms.component';
import { CaseCreateWizardComponent } from '../modules/case-create-wizard/case-create-wizard.component';
import { TreatmentPlanningComponent } from '../modules/treatment-planning/treatment-planning.component';
import { eRxComponent } from '../modules/erx/erx.component';
import { InsuranceManagementComponent } from '../modules/insurance/insurance-management/insurance-management.component';
import { AuthGuard } from '../modules/auth/helpers/authguard';
import {ArFeeCalculationComponent} from '../modules/ar/fee-calculation/ar-fee-calculation/ar-fee-calculation.component';
import {ArLedgerComponent} from '../modules/ar/ledger/ar-ledger/ar-ledger.component';
import {ClaimManagementComponent} from '../modules/ar/claims/claim-management/claim-management.component';
import {OrganizerComponent} from '../main-interface/organizer/organizer.component';
import {TreatmentComponent} from '../modules/treatment/treatment.component';
import {ArPaymentAuditComponent} from '../modules/ar/payment/ar-payment-audit/ar-payment-audit.component';
import {ArInsurancePaymentComponent} from '../modules/ar/payment/ar-insurance-payment/ar-insurance-payment.component';
import {TestingComponent} from './testing/testing.component';
import {MedicalHistoryComponent} from '../modules/medical-history/medical-history.component';
import {RecallComponent} from '../modules/recall/recall.component';
import {RoleGuard} from '../modules/auth/helpers/role-guard';
import {NotificationToFrontCreateDialogComponent} from '../dialog/notifications/notification-to-front-create-dialog/notification-to-front-create-dialog.component';
import {PerioComponent} from '../modules/perio/perio.component';
import {ReferralManagerComponent} from '../modules/referral-manager/referral-manager.component';
import { CommonModule } from '@angular/common';

const routes: Routes = [{
  path: 'landing',
  component: LandingComponent,
  canActivate: [AuthGuard],
  canActivateChild: [RoleGuard],
  children: [
    { path: 'case-view', component: CaseFormsComponent },
    { path: 'visit', component: CaseCreateWizardComponent },
    { path: 'organizer', component: OrganizerComponent },
    { path: 'treatment-plan', component: TreatmentPlanningComponent },
    { path: 'treatment', component: TreatmentComponent },
    { path: 'erx', component: eRxComponent },
    { path: 'patient-insurance', component: InsuranceManagementComponent },
    { path: 'fees', component: ArFeeCalculationComponent },
    { path: 'ledger', component: ArLedgerComponent },
    { path: 'claims', component: ClaimManagementComponent },
    { path: 'medical-history', component: MedicalHistoryComponent },
    { path: 'recall', component: RecallComponent },
    // { path: 'payment-audit', component: ArPaymentAuditComponent },
    { path: 'insurance-payment', component: ArInsurancePaymentComponent },
    { path: 'notes-to-front', component: NotificationToFrontCreateDialogComponent },
    { path: 'testing', component: TestingComponent},
    { path: 'perio', component: PerioComponent},
    { path: 'referrals', component: ReferralManagerComponent}
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes),
  CommonModule],
  exports: [RouterModule]
})
export class LandingRoutingModule { }
